import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Textarea
name: Textarea
category: React - Bulma
---

A `Textarea` component based on Bulma `.textarea`. This is a wrapper for textarea fields.

If you're trying to build a form, take a look at the different `Field` components.
Using those will help ensure consistency.

See [Bulma Documentation](http://bulma.io/documentation/form/textarea/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <form>
    <Field>
      <Label htmlFor="example">Input name</Label>
      <Control>
        <Textara name="example" onChange={onChangeHandler} />
      </Control>
    </Field>
  </form>
```
*/
/**
* @TODO Automatically set accessibility attributes.
* @TODO Add support for input states.
* @TODO Add support for icons.
*/
function Textarea(props) {
  const {
    name, value, className, inputSize, onChange, ...rest
  } = props

  const classes = [
    'textarea',
    inputSize ? `is-${inputSize}` : '',
    className || '',
  ]

  const onChangeHandler = (e) => {
    if (typeof onChange === 'function') {
      onChange(name, e.target.value)
    }
  }

  return (
    <textarea
      id={name}
      {...rest}
      name={name}
      onChange={onChangeHandler}
      className={classes.join(' ')}
      defaultValue={value}
    />
  )
}

Textarea.propTypes = {
  // Name/id of input.
  name: PropTypes.string.isRequired,
  // Size of input: "small", "medium", "large"
  inputSize: PropTypes.string,
}

export default Textarea
